import ENVIRONMENT_VAR from "@/src-refactor/modules/shared/model/const/env/env.const";
import useUserHelp from "./useUserHelp";

export interface IShareWaItem {
  id: string;
  typeProperty?: string;
  businessType?: string;
  sector?: string;
  title?: string;
  customMessage?: string;
}

export const useSharedWa = () => {
  const { USER } = useUserHelp();

  const generateUrl = (item: IShareWaItem) => {
    const referer = USER?.userData?.people_id || "";
    const typeProperty = item.typeProperty?.replaceAll(" ", "-") || "";

    return {
      url: `${ENVIRONMENT_VAR.REMAX_DOMAIN}/propiedad/${typeProperty}/${item.id}?referer=${referer}`,
      title:
        item.title ||
        `${typeProperty} en ${item?.businessType || ""} en ${item?.sector || ""}`,
      subject: `${typeProperty} en ${item?.businessType || ""} en ${
        item?.sector || ""
      }`,
      body: `${typeProperty} en ${item?.businessType || ""} en ${
        item?.sector || ""
      } \n `
    };
  };

  const sharedWa = (items: IShareWaItem | IShareWaItem[]) => {
    const itemsArray = Array.isArray(items) ? items : [items];

    const urls = itemsArray.map(item => {
      const generatedUrl = generateUrl(item);
      return `${item.customMessage || generatedUrl.title}: ${generatedUrl.url}`;
    });

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      urls.toString().replace(/,/g, "\n")
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return { sharedWa };
};

export default useSharedWa;
